module.exports = __webpack_public_path__ + "static/img/title-dpdz-new.ae62fa10.png";